import {
  Grid,
} from '@material-ui/core';
import { searchSchoolsPartners } from '@webapps/business';
import {
  Modal,
  PaginationNumbers,
  useAuth,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';

import AddPartner from './AddPartner';
import PartnerCard from './PartnerCard';
import FilterPartners from './FilterPartners';
import Nodata from 'components/NoData';
import PartnerCardSkeleton from './PartnerCardSkeleton';
import theme from '../theme';

const Partner = ({ from, accept, setTotalElements }) => {
  const {
    classes,
    css,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const {
    images: { Actions }
  } = theme

  const { idUser } = useAuth();
  const { addToast } = useToast();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6: 4);
  const [addPartner, setAddPartner] = useState(false);

  const [keywordRequest, setKeywordRequest] = useState('');
  const [sectorsRequest, setSectorsRequest] = useState('');
  const [domainsRequest, setDomainsRequest] = useState('');
  const [typeRequest, setTypeRequest] = useState('');

  const { data: { content: partners = [], totalElements } = {}, refetch, isLoading } = useQuery(searchSchoolsPartners, {
    key: ['schoolsPartnersRequest', page, size, idUser, keywordRequest, sectorsRequest, domainsRequest, typeRequest, from, accept],
    variables: {
      id: idUser,
      keyword: keywordRequest,
      sectors: sectorsRequest,
      domains: domainsRequest,
      type: typeRequest,
      from,
      accept,
      page: page - 1,
      size
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const formik = useFormik({
    initialValues: {
      keyword: '',
      sectors: [],
      domains: [],
      type: '',
    },
    onSubmit: ({
      keyword,
      sectors,
      domains,
      type,
    }) => {
      setKeywordRequest(keyword);
      setSectorsRequest(sectors);
      setDomainsRequest(domains);
      setTypeRequest(type?.value);
      setPage(1);
    },
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      formik.handleSubmit();
    }, 500);

    return () => {
      if (formik.values.keyword !== keywordRequest)
        clearTimeout(handler);
      else
        formik.handleSubmit();
    };
  }, [formik.values]);

  useEffect(() => {
    setTotalElements(totalElements);
  }, [totalElements]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        height: '100%',
      }}
    >
      <Grid container className={classes.container}>
        <FilterPartners formik={formik} partners={partners} refetch={refetch} accept={accept} />
      </Grid>
      {
        isLoading ? (
          <Grid className={classes.partnerContainer} container>
            {[...Array(size/2)].map((_, idx) => (
              <Grid key={idx} item xs={12} sm={6} md={4} xl={3} style={{ padding: spacing(0, 2.5, 2.5, 0) }} >
                <PartnerCard item={{}} isLoading={true} />
              </Grid>
            ))}
          </Grid>
        ) :
          !partners?.length ? (
            <Grid className={classes.noResultContainer} container >
              <Nodata
                image={Actions}
                contentWidth='70%'
                padding='0px 20px 20px 0px'
                width="150px"
                title="Aucun partenaire trouvé"
                description="Les partenaires correspondants à vos critères de recherche apparaîtront ici."
              />
            </Grid>
          ) : (
            <Grid className={classes.partnerContainer} container>
              {partners?.map(
                (info) => (
                  <Grid key={info.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: spacing(0, 2.5, 2.5, 0) }} >
                    <PartnerCard
                      info={info}
                      refetch={refetch}
                      type={from}
                      accept={accept}
                    />
                  </Grid>
                )
              )}
            </Grid>
          )
      }

      {partners?.length > 0 && (
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      )}
      <Modal
        onCancel={() => setAddPartner(false)}
        open={addPartner}
        title="Rechercher un partenariat"
        titleFontSize={'20px'}
        titleFontWeigth={500}
        maxWdth={'80%'}
      >
        <AddPartner
          close={() => setAddPartner(false)}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    columnGap: 10,
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      columnGap: 0,
      rowGap: 10,
    },
  },
  noResultContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 75px - 193px)',
    padding: spacing(2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
  partnerContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    padding: spacing(2.5, 0, 0, 2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
});

export default Partner;
